import { useState } from "react";

export default function ScheduleCampaignReviewPage() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="h-screen w-full">
      {isLoading && (
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
        </div>
      )}
      <iframe
        src="https://cal.com/asher-projectsg/gpr15min"
        style={{
          minHeight: "100svh",
        }}
        className={`w-full min-h-screen flex justify-center items-center h-full border-0 ${isLoading ? "hidden" : ""}`}
        title="Schedule Campaign Review"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
}
